import { render } from "./GameStart.vue?vue&type=template&id=4122c84e"
import script from "./GameStart.vue?vue&type=script&lang=js"
export * from "./GameStart.vue?vue&type=script&lang=js"

import "./GameStart.vue?vue&type=style&index=0&id=4122c84e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__